import { useNavigate } from "react-router-dom";
import { Icons } from "../assets/icons/Icons";

export default function TransactionItem({ transaction }) {
    const { type, description, amount, date } = transaction;
    const navigate = useNavigate();

    // Determine icon component
    const IconComponent = getIconComponent(type);

    // Determine amount color and prefix
    const isNegative = amount < 0;
    const isNeutral = type === "plan_activation";

    let amountColor = "text-success"; // Default for positive
    let prefix = "+ ";

    if (isNegative) {
        amountColor = "text-danger";
        prefix = "- ";
    } else if (isNeutral) {
        amountColor = "text-info";
        prefix = "= ";
    }

    // Format amount (remove negative sign as we use prefix)
    const formattedAmount = `$${Math.abs(amount).toFixed(2)}`;

    return (
        <div
            className="d-flex align-items-center justify-content-between mb-3"
            onClick={() => navigate("/transaction-detail")}
            style={{ cursor: "pointer" }}
        >
            <div className="d-flex align-items-center">
                <div className="me-3">{IconComponent}</div>
                <div>
                    <h3
                        className=" text-white m-0 p-0"
                        style={{ fontSize: "16px" }}
                    >
                        {type}
                    </h3>
                    <p
                        className="text-secondary small m-0 p-0"
                        style={{
                            fontSize: "10px",
                            color: "rgba(255, 255, 255, 0.6)",
                        }}
                    >
                        {description}
                    </p>
                </div>
            </div>
            <div className="text-end">
                <p
                    className={` ${amountColor} mb-0 m-0 p-0`}
                    style={{ fontSize: "16px" }}
                >
                    {prefix}
                    {formattedAmount}
                </p>
                <p
                    className="text-secondary mb-0 small m-0 p-0"
                    style={{
                        fontSize: "10px",
                        color: "rgba(255, 255, 255, 0.6)",
                    }}
                >
                    {date}
                </p>
            </div>
        </div>
    );
}

function getIconComponent(iconName) {
    switch (iconName) {
        case "withdraw":
            return <Icons.Withdraw />;
        case "deposit":
            return <Icons.Deposit />;
        case "exchange":
            return <Icons.Exchange />;
        case "plan_activation":
            return <Icons.Plan />;
        default:
            return <Icons.Withdraw />;
    }
}
